import {
  GET_USERS_ACTIONS,
  SET_USERS_ACTIONS,
  USERS_ACTIONS_LOADER,
  GET_USERS_ACTIONS_FILTERS,
  SET_USERS_ACTIONS_FILTERS,
  USERS_ACTIONS_LOADER_FILTER
} from "./actionTypes";

export const getUsersActions = (data) => ({
  type: GET_USERS_ACTIONS,
  payload: data
})

export const setUsersActions = (data) => ({
  type: SET_USERS_ACTIONS,
  payload: data
})

export const loaderUserActions = () => ({
  type: USERS_ACTIONS_LOADER
})

export const getUsersActionsFilters = () => ({
  type: GET_USERS_ACTIONS_FILTERS,
})

export const setUsersActionsFilters  = (data) => ({
  type: SET_USERS_ACTIONS_FILTERS,
  payload: data
})

export const loaderUserActionsFilters  = () => ({
  type: USERS_ACTIONS_LOADER_FILTER
})
